//CSS Imports
//import '../sass/theme.scss';

//JS imports
// JavaScript Document
"use strict";

//se hace el import e integracion del jQuery cuando se carga desde webpack
// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;


(function($) {      
    jQuery(function ($) {

		require('./popups.js');
		require('./common.js');
		require('./forms.js');
      	console.log('Ready Function');
		jQuery('#participaciones-history .post-entry-content .premio a').each((index, element) =>{
			jQuery(element).on('click',e => {
				e.preventDefault();
				let target = jQuery(element).attr("class");
				let article_name =jQuery(element).closest('article').data('name');
				jQuery('#form-field-envios_participacion_id').val(article_name.substr(article_name.indexOf('# ')+2));
				jQuery('#main .ruleta-activo').removeClass('ruleta-activo');
                jQuery("#ruleta-"+target).addClass('ruleta-activo');
				jQuery("#section-participaciones").toggle();
				if(jQuery(element).data("premio-form-enviado")){
					jQuery('#form_premios').parent().html('<span>Su información se ha enviado correctamente. Gracias</span>');
				}
				if(jQuery(element).data("premio-code")){
					// let copiarCodigo = jQuery("#ruleta-"+target).find('#form-field-codigo_premio');
                	// jQuery(copiarCodigo).val(jQuery(element).data("premio-code"));
					jQuery('#form-field-envios_premio').val(jQuery(element).data("premio-code"));

				}
			})
		});
		if(jQuery('#ruleta-section .datos .intentos .cantidad-p').length > 0){
			if(parseInt(jQuery('#ruleta-section .datos .intentos .cantidad-p').text(),10) > 0) {
				jQuery('#ruleta-section .btn-ruleta a').removeClass('isDisabled');
			}
		}
		if(jQuery('#form_premios')){
			jQuery('#form_premios').on('submit_success',e =>{
				jQuery(e.target).parent().html('<span>Su información se ha enviado correctamente. Gracias</span>');
			})
		}
    });
  
})($);
